import {Options, AxisLabelsFormatterContextObject} from "highcharts";
import {registerPlugin} from "surveylabJsAssets/chart/charts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";

export class ProfileChart extends AbstractChart {
    protected allChartOptions(): Options {
        const yAxisLabels = ($(this.target).data('y-axis-labels') || {}) as Record<number, string>;

        // Legacy base options from highcharts-base.js. These should be applied first,
        // while the more specific options below (and data-options from the DOM) take precedence.
        const baseOptions: Options = {
            chart: {
                style: {
                    fontFamily: '"Roboto", Helvetica, Arial, sans-serif'
                }
            },
            xAxis: {
                labels: {
                    useHTML: true
                }
            },
            yAxis: {
                title: {
                    // Disable title
                    text: null as any
                },
                labels: {
                    useHTML: true
                }
            },
            plotOptions: {
                series: {
                    // Avoid problems with PDF
                    animation: false
                }
            },
            title: {
                text: null as any
            },
            legend: {
                enabled: false
            },
            tooltip: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            }
        };

        const options: Options = {
            chart: {
                // Match legacy sizing/margins
                marginTop: 24,
                marginBottom: 40,
                width: 415,
                height: 250,
            },
            // Keep legend hidden like legacy base settings
            legend: {enabled: false},
            plotOptions: {
                series: {
                    // Series-wide options
                },
                bar: {
                    // Bar height moved here (was on series), as pointWidth is series-type specific in newer Highcharts
                    pointWidth: 17,
                    borderWidth: 0,
                }
            },
            xAxis: {
                labels: {
                    // xAxis is labelled separately outside the chart
                    enabled: false,
                },
                tickWidth: 0,
            },
            yAxis: {
                min: 1,
                max: 5,
                tickInterval: 1,
                labels: {
                    align: 'center',
                    formatter: function (this: AxisLabelsFormatterContextObject) {
                        // Use mapping provided by server to render HTML labels
                        // this.value is typed as (number|string), we expect number keys
                        return (yAxisLabels as any)[this.value as any] || '';
                    }
                },
            },
        };

        // Apply legacy base options first, then plugin-specific options so they take precedence.
        // Data-provided options are merged later in AbstractChart.preCreationOptions().
        return super.mergeOptions(super.allChartOptions(), baseOptions, options);
    }
}

export default function () {
    registerPlugin(ProfileChart);
}
